export default __webpack_public_path__ + "static/media/mysql.d4538edf.png";